import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
import { RetailersService } from '../retailers.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlItem } from 'src/app/models/frontend';
import { DiscountTemplatesService } from '../../discount-templates/discount-templates.service';
import { IPagedDiscountTemplateResultRequestDto, IUpdateRetailerDto } from 'src/app/models/backend';
import { Toast, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-discount-template',
  templateUrl: './update-discount-template.component.html',
  styleUrls: ['./update-discount-template.component.scss']
})
export class UpdateDiscountTemplateComponent implements OnInit  {

loader=false;
retailerForm:FormGroup;
retailer:IUpdateRetailerDto;
DiscountTemplates:ControlItem[]=[]
request: IPagedDiscountTemplateResultRequestDto = {
  isInvoledDeletedItems: false,
  skipCount: 0,
  maxResultCount: 100
};

constructor(private fb:FormBuilder,private retailerService:RetailersService
  ,private discountService:DiscountTemplatesService,
  private toastr:ToastrService,
  public activeModal: NgbActiveModal
){}

ngOnInit(): void {
  this.loader=true;
  this.LoadDiscountTemplates();
  this.retailerService.GetRetailerById(this.retailerService.id).subscribe({
    next:(val:any)=>{
      this.retailer=val;
      this.retailerForm=this.fb.group({
        discountTemplateId:[val.discountTemplateId, [Validators.required, Validators.maxLength(100)]],
      });
      console.log('retailer form',this.retailerForm);
    },
    error:(err:any)=>{},
    complete:()=>{this.loader=false;}
  })
}
onSubmit() {
 this.loader=true;
 this.retailer.discountTemplateId=this.retailerForm.value.discountTemplateId;
 this.retailerService.UpdateRetailerDiscount(this.retailer).subscribe({
  next:(val:any)=>{
    this.toastr.success('Updated','Success');
  },
  error:(err:any)=>{
    this.toastr.error('error','error')
  },
  complete:()=>{
    this.loader=false;
    this.activeModal.close({ refresh: true });  
  }
 })
}


LoadDiscountTemplates(){
  this.discountService.GetDiscountTemplates(this.request).subscribe((res:any)=>{
    console.log(res)
    for(let i=0;i<=res.items.length;i++){
      this.DiscountTemplates.push({label:res.items[i].name,value:res.items[i].id})
    }
  })
}

}
